import CustomModal from "../Modal";

import { StaffShiftHistoryContent } from "./StaffShiftHistoryContent";
import { TTarget } from "./types";

export const StaffShiftHistoryModal = ({
  onClose,
  modalTitle,
  withBlurBackground = true,
  ...target
}: TTarget & {
  modalTitle: string;
  withBlurBackground?: boolean;
  onClose: () => void;
}) => {
  return (
    <CustomModal
      sx={{ ".modal-content-container": { overflowY: "auto", maxHeight: "80vh" } }}
      modalHeaderText={modalTitle}
      modalContent={<StaffShiftHistoryContent target={target} />}
      isOpen={true}
      withBlurBackground={withBlurBackground}
      onClose={onClose}
    />
  );
};
